import { createSlice } from "@reduxjs/toolkit";
import { spaceEdit } from "./spaceAsyncThunk";

const spaceEditSlice = createSlice({
  name: "space",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [spaceEdit.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [spaceEdit.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [spaceEdit.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default spaceEditSlice.reducer;
